import type { RouteObject } from 'react-router';
import { CalendarPage } from './CalendarPage';

export const routes: RouteObject[] = [{ path: '/calendar', element: <CalendarPage /> }];
